module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/change-property/change-property.component.html
// module id = ./src/app/allocation/change-property/change-property.component.html
// module chunks = main